var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 0.75V17.25H1.74992C1.5068 17.25 1.27365 17.1534 1.10174 16.9815C0.929829 16.8096 0.833252 16.5764 0.833252 16.3333V11.2917C1.44104 11.2917 2.02393 11.0502 2.45371 10.6205C2.88348 10.1907 3.12492 9.60779 3.12492 9C3.12492 8.39221 2.88348 7.80932 2.45371 7.37955C2.02393 6.94978 1.44104 6.70833 0.833252 6.70833V1.66667C0.833252 1.42355 0.929829 1.19039 1.10174 1.01849C1.27365 0.846577 1.5068 0.75 1.74992 0.75H11.8333ZM13.6666 0.75H18.2499C18.493 0.75 18.7262 0.846577 18.8981 1.01849C19.07 1.19039 19.1666 1.42355 19.1666 1.66667V6.70833C18.5588 6.70833 17.9759 6.94978 17.5461 7.37955C17.1164 7.80932 16.8749 8.39221 16.8749 9C16.8749 9.60779 17.1164 10.1907 17.5461 10.6205C17.9759 11.0502 18.5588 11.2917 19.1666 11.2917V16.3333C19.1666 16.5764 19.07 16.8096 18.8981 16.9815C18.7262 17.1534 18.493 17.25 18.2499 17.25H13.6666V0.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.f849f61e.svg";
export { ForwardRef as ReactComponent };